import PRODUCTS_SELECTOR_TABS from '../../models/productsSelectorTabs.js';
import SORT from '../../models/sort.js';
import _ from 'lodash';

class ProductsSelectorController {
  constructor(entitlerService, $state, $scope, navBarService, statusIndicatorService, localStorageService, config, AuthenticationService, customerIntegrationsService) {
    this.localStorageService = localStorageService;
    this.authenticationService = AuthenticationService;
    this.customerIntegrationsService = customerIntegrationsService;
    this.token = this.localStorageService.get('token');
    this.user = this.authenticationService.getUserFromToken(this.token);
    this.hasA3kIntegrations;
    this.userType = +this.localStorageService.get('role');
    this.usersAllowedToImport = [2, 4, 42];
    this.isImporting = false;
    this.name = 'productsSelector';
    this.$state = $state;
    this.entitlerService = entitlerService;
    this.setTabDataBasesOnCurrentState();
    this.offset = 0;
    this.searchValue = '';
    this.ROWS_PER_PAGE = 200;
    this.sort = SORT;
    this.sortBy = {
      column: 'name',
      order: this.sort.ascending
    };
    this.allProducts = [];
    this.previousData = {
      content: []
    };
    this.options = this.tab.options;
    this.navBarService = navBarService;
    this.batchIsInProgress = false;
    this.workflowIsInProgress = false;
    this.purchasingAccountNumbers = [];
    this.selectedPurchasingAccountNumber = null;
    this.statusIndicatorService = statusIndicatorService;
    this.config = config;
    this.assignErrorsLegend = {
      title: 'ASSIGN_ERROR_LEGEND_TITLE',
      bottomText: 'ASSIGN_ERROR_LEGEND_BOTTOM',
      items: [
        {
          text: 'ASSIGN_ERROR_LEGEND_ITEM_EXPIRY',
          iconClass: 'error-severity-3'
        },
        {
          text: 'ASSIGN_ERROR_LEGEND_ITEM_EXCEED',
          iconClass: 'error-severity-2'
        }
      ]
    };
    if (!this.isResourceView() && !this.isMasterTemplateView()){
      this.getProducts();
      navBarService.setActiveTab($state.current.name);
    }

    //If selected product(radio) changes add to entitler.selectedProducts(Object used to maintain the selections for the flow)
    $scope.$watch(() => this.metaData.entitler.selectedProduct, this.addSelectedProductToEntitler.bind(this));
    this.initialCall = true;
  }

  getCustomerIntegrations(customerId, type, key) {
    return this.customerIntegrationsService.getAllIntegrations({
      customerId: customerId,
      type: type,
      key: key
    }).then(this.onIntegrationsReceived.bind(this));
  }

  onIntegrationsReceived(response) {
    this.hasA3kIntegrations = response.data.content[0] || {};
  }
  
  addSelectedProductToEntitler() {
    let masterTemplate;
    let currentMasterTemplate;
    let isToUpdateEntitler;

    if(this.isMasterTemplateView()){
      isToUpdateEntitler = this.metaData.entitler.selectedProduct && this.entitler.allResources;
    } else {
      isToUpdateEntitler = this.metaData.entitler.selectedProduct && this.data;
    }

    if (isToUpdateEntitler) {
      let products;
      if (this.isResourceView()) {
        this.entitler.selectedResources = [];
        products = this.entitler.selectedResources;
      } else if (this.isMasterTemplateView()) {
        currentMasterTemplate = this.getSelectedProduct(this.entitler.aleksMasterTemplateData, this.metaData.entitler.selectedProduct);
        this.entitler.selectedResources = [];
        this.entitler.selectedAleksMasterTemplate = [];
        products = this.entitler.selectedResources;
        masterTemplate = this.entitler.selectedAleksMasterTemplate;
      } else {
        this.entitler.selectedProducts = [];
        this.entitler.selectedResources = [];
        products = this.entitler.selectedProducts;
      }

      let productToAdd;
      let templateToAdd;

      if(this.isMasterTemplateView() && currentMasterTemplate) {
        templateToAdd = this.getSelectedProduct(this.entitler.aleksMasterTemplateData, this.metaData.entitler.selectedProduct);
        productToAdd = this.getSelectedProduct(this.entitler.allResources, currentMasterTemplate.courseExternalId);
      } else {
        productToAdd = this.getSelectedProduct(this.allProducts, this.metaData.entitler.selectedProduct);
      }

      if (this.isResourceView()) {
        this.entitler.selectedResources.push(productToAdd);
      } else if (this.isMasterTemplateView()) {
        this.entitler.selectedAleksMasterTemplate.push(templateToAdd);
        this.entitler.selectedResources.push(productToAdd);
      } else {
        this.entitler.selectedProducts.push(productToAdd);
      } 
    }
  }

  onAccountChange(){
    this.data = {
      content: []
    };
    localStorage.setItem('PurchasingAccountNumbers',this.selectedPurchasingAccountNumber);
    this.resetPaginationDefaults();
    this.getProducts();
  }

  setTabDataBasesOnCurrentState() {
    let tabs = PRODUCTS_SELECTOR_TABS;
    this.currentState = this.getCurrentState();
    let tabValue = _.find(tabs, (tab) => {
      return tab[this.currentState];
    });
    this.tab = tabValue[this.currentState];
  }

  getCurrentState() {
    const currentStateName = this.$state.current.name;
    if (_.includes(currentStateName, 'resource')) return 'resource';
    if (_.includes(currentStateName, 'aleks')) return 'aleks-master-templates';
    if (_.includes(currentStateName, 'assign') && !this.isLicenseTypeBUIP()) {
      return 'assign';
    } else {
      return 'manage';
    }
  }

  isAssignFlow() {
    return this.currentState === 'assign';
  }

  isResourceView() {
    return this.currentState === 'resource';
  }

  isMasterTemplateView() {
    return this.currentState === 'aleks-master-templates';
  }

  isManageFlow() {
    return  this.isLicenseTypeBUIP();
  }

  isLicenseTypeBUIP() {
    return this.localStorageService.get('licensingType') === 'BUIP+';
  }

  reloadProductSelections(entitler) {
    if(!this.isResourceView() && !this.isMasterTemplateView()){
      this.metaData.entitler.selectedProduct = entitler.selectedProducts[0] !== undefined  ? entitler.selectedProducts[0].id : undefined;
    }else{
      //if the resources data is already fetch use stateParams if not fetch the resources.
      if(this.$state.params.data){
        this.onProductsRetreivalSuccess(this.$state.params.data);
      }else{
        if(!entitler.selectedProducts[0]){
          this.$state.go('home.assign.productsSelector');
        } else {
          this.getProducts();
        }
      }
      this.metaData.entitler.selectedProduct = entitler.selectedResources[0] !== undefined  ? entitler.selectedResources[0].id : undefined;
    }
  }

  getProducts() {
    let fetchMethod = this.tab.options.fetchMethod;
    let selectedProduct = null;
    if(this.isResourceView() || this.isMasterTemplateView()){
      selectedProduct = this.entitler.selectedProducts.length !== 0 ? this.entitler.selectedProducts[0].id : null;
    }
    // check for hidea3k customer integration to filter products visible on the Assign screen
    this.getCustomerIntegrations(this.user.customerId, 'Matrix', 'hidea3k');
   
    const query = {
      offset: this.offset,
      sortBy: this.sortBy,
      limit: this.ROWS_PER_PAGE,
      productId: selectedProduct,
      searchValue: this.searchValue,
      purchasingAccountNumber: this.selectedPurchasingAccountNumber,
    };
    if(fetchMethod === 'fetchProductsByCustomer'){
      _.set(query, 'licensingType', this.localStorageService.get('licensingType'));
    }

    this.entitlerService[fetchMethod](query).then(this.onProductsRetreivalSuccess.bind(this), this.onProductsRetreivalFailure.bind(this));
  }

  onProductsRetreivalSuccess(successResponse) {
    const purchasingAccountNumbers = (!this.isResourceView() && !this.isMasterTemplateView()) ? successResponse.data.content.data.purchasingAccountNumbers : [];
    this.getSelectedPurchasingAccountNumber(purchasingAccountNumbers);
    this.getProductDataList(successResponse);
  }

  getSelectedPurchasingAccountNumber(purchasingAccountNumbers){
    if (purchasingAccountNumbers && purchasingAccountNumbers.length) {
      this.purchasingAccountNumbers = _.map(purchasingAccountNumbers, (account) => {
        return Object.assign({}, account, {
          name: `${account.purchasingAccountName} | ${account.oksAccountNumber}`
        });
      });
      let storedPurchasingAccount = localStorage.getItem('PurchasingAccountNumbers');
      //geting selectedPurchasingAccountNumber from local storage if its present
      if (!this.selectedPurchasingAccountNumber) {
        // Once preference service is  available, Precedence will given to preference value over the local storage
        if (purchasingAccountNumbers.some(obj => obj.purchasingAccountNumber && storedPurchasingAccount === obj.purchasingAccountNumber)) {
          this.selectedPurchasingAccountNumber = storedPurchasingAccount;
        } else {
          this.selectedPurchasingAccountNumber = purchasingAccountNumbers[0].purchasingAccountNumber;
          localStorage.setItem('PurchasingAccountNumbers', purchasingAccountNumbers[0].purchasingAccountNumber);
        }
      }
    }
  }

  getProductDataList(successResponse){
    if (this.initialCall) {
      this.initialCall = false;
      this.getProducts();
    } else {
      const contentWithPurchasedSeats = this.isResourceView() || this.isMasterTemplateView() ? successResponse.data.content.data : this.filterPurchasedSeatsItems(successResponse.data.content.data.products);

      this.data = {
        content: this.previousData.content.concat(contentWithPurchasedSeats)
      };

      if(this.hasA3kIntegrations && Object.keys(this.hasA3kIntegrations).length > 0) {
        if(this.hasA3kIntegrations.value === 'ActivelyLearn'){
          this.data.content = this.data.content.filter(product => !(product.platform === 'al' && product.productCategory === 'primary'));
        }
        if(this.hasA3kIntegrations.value === 'A3KLiteracy'){
          this.data.content = this.data.content.filter(product => product.platform !== 'a3k_literacy');
        }
        if(this.hasA3kIntegrations.value === 'All'){
          this.data.content = this.data.content.filter(product => !(product.platform === 'al' && product.productCategory === 'primary') && product.platform !== 'a3k_literacy');
        }
      }

      if(this.isMasterTemplateView()){
        this.data.content = this.data.content
          .filter(template => {
            const associatedResource = this.getSelectedProduct(this.entitler.allResources, template.courseExternalId);
            return associatedResource;
          })
          .map((template) => {
            const associatedResource = this.getSelectedProduct(this.entitler.allResources, template.courseExternalId);
            return Object.assign({}, template, {courseProduct: associatedResource.name});
          });
      }
      
      this.allProducts = _.uniq(this.allProducts.concat(this.data.content), (productData) => {
        return productData.id;
      });
      this.previousData = this.data;
      this.offset += this.ROWS_PER_PAGE;
      this.metaData.entitler.search.errors.NO_SEARCH_RESULTS = this.data.content.length === 0;

      if (this.isResourceView() || this.isMasterTemplateView()) {
        // If this is the resource view, make sure they're ALEKS resources before offering the MT flow
        this.offerAleksMasterTemplateFlow = this.areAleksResources(this.allProducts);
      } else {
        // If it isn't the resource view, check the products to determine whether any are ALEKS
        this.offerAleksMasterTemplateFlow = this.hasAnyAleksProducts(this.allProducts);
        this.aleksProducts = _.filter(this.allProducts, { 'platform': 'aleks' });
      }


      // console.log('getProductDataList > this.offerAleksMasterTemplateFlow: ', this.offerAleksMasterTemplateFlow);
      // console.log('getProductDataList > this.allProducts: ', this.allProducts);

    }
  }


  filterPurchasedSeatsItems(content) {
    return _.filter(content, (row) =>
    {
      if (row.seatsExpiry)
      {
        let totalSeats = null;
        row.seatsExpiry.forEach((seatExpiry) => {
          if (seatExpiry.seats) {
            totalSeats += seatExpiry.seats;
          }
        });
        row.seatsPurchased = totalSeats;
      }
      return row.seatsPurchased !== 0;
    });
  }

  onProductsRetreivalFailure() {}

  assignMasterTemplates() {
    // console.log('Clicked "Assign Master Templates Button!');
    // console.log('master template data ::: ', this.entitler.aleksMasterTemplateData)
    // console.log('THIS: ', this)
    this.$state.go('home.assign.aleksMasterTemplateSelector', { data: this.entitler.aleksMasterTemplateData, resources: this.data.content });
  }

  importProducts() {
    this.isImporting = true;
    this.entitlerService.importProducts().then(this.onImportProductsSuccess.bind(this), this.onImportProductsFailure.bind(this));
  }

  onImportProductsSuccess(successResponse) {
    console.log('Import products success!', successResponse);
  }

  onImportProductsFailure(errorResponse) {
    // If this isn't prod, log the error instead of disappearing it.
    if (this.config.env !== 'prod') {
      console.warn('Failure encountered while attempting to import products');
      console.error('onImportProductsFailure > errorResponse: ', errorResponse);
    }
  }

  submitSelectedProducts() {
    let selectedProduct;

    if(this.isMasterTemplateView()){
      selectedProduct = this.getSelectedProduct(this.entitler.aleksMasterTemplateData, this.metaData.entitler.selectedProduct);
    } else {
      selectedProduct = this.getSelectedProduct(this.allProducts, this.metaData.entitler.selectedProduct);
    }

    this.setEntitlerDefaults();
    this.workflowIsInProgress = false;
    this.batchIsInProgress = false;
    if (selectedProduct) {
      this.statusIndicatorService.getStatus().then((response) => {
        const batch = response && response.data && response.data.content;
        const assignProductByBatchWorkflow = _.find(batch && batch.workflowTransitions, (a) => a.job === 'assignProductsByBatch' && a.serviceName === 'sections');
        this.batchIsInProgress = assignProductByBatchWorkflow && (assignProductByBatchWorkflow.status === 'IN_PROGRESS' || assignProductByBatchWorkflow.status === 'QUEUED');
        if (!this.batchIsInProgress) {
          this.entitlerService.lastWorkflowForProductAssignment(selectedProduct).then((response) => {
            this.workflowIsInProgress = response && response.data && (response.data.isInProcess || response.data.isQueued);
            if (!this.batchIsInProgress && !this.workflowIsInProgress) {
              if (this.doesPlatformHasResourceView(selectedProduct.platform) && !this.isResourceView() && !this.isMasterTemplateView()) {
                //fetch the resources to check iff its 1:1 mapping to do auto-assignment of resources.
                const sortOption = {
                  column: 'name',
                  order: this.sort.ascending
                };
                // console.log('submitSelectedProducts > sortOption: ', sortOption);
                // console.log('submitSelectedProducts > selectedProduct: ', selectedProduct);
                // console.log('submitSelectedProducts > this.config: ', this.config);
                // If this is an ALEKS product, shall we fetch Master Templates now?
                if (selectedProduct.platform && selectedProduct.platform === 'aleks') {
                  // console.log('Is an ALEKS product! Let us try fetching Master Templates!');
                  this.entitlerService.fetchALEKSMasterTemplatesByProduct({
                    offset: 0,
                    searchValue: '',
                    // sortBy: sortOption,
                    limit: this.ROWS_PER_PAGE,
                    productId: selectedProduct.id,
                  }).then(this.onALEKSMasterTemplateRetreivalSuccess.bind(this), this.onALEKSMasterTemplateRetreivalFailure.bind(this));
                }
                this.entitlerService.fetchResourcesByProduct({
                  offset: 0,
                  searchValue: '',
                  sortBy: sortOption,
                  limit: this.ROWS_PER_PAGE,
                  productId: selectedProduct.id,
                  purchasingAccountNumber: this.selectedPurchasingAccountNumber,
                }).then(this.onResourceRetreivalSuccess.bind(this), this.onProductsRetreivalFailure.bind(this));
              } else {
                this.$state.go('home.assign.assignments', {
                  tabName: 'courses'
                });
              }
            }
          });
        }
      });

    } else {
      this.hasNoSelections = true;
    }
  }

  /**
 * Callback to successful fetch request for ALEKS Master Templates.
 * @param {Object} successResponse resource data
 */
  onALEKSMasterTemplateRetreivalSuccess(successResponse) {
    // console.log("YAY! Retrieved ALEKS Master Template Data!", successResponse);
    // console.log('onALEKSMasterTemplateRetreivalSuccess > this.entitler: ', this.entitler);
    // console.log('onALEKSMasterTemplateRetreivalSuccess > this: ', this);
    this.masterTemplateData = successResponse.data.content.data;
    this.entitler.aleksMasterTemplateData = this.masterTemplateData;
  }

  onALEKSMasterTemplateRetreivalFailure(errorResponse) {
    // If this isn't prod, log the error instead of disappearing it.
    if (this.config.env !== 'prod') {
      console.warn('Failure encountered while attempting to retrieve ALEKS Master Templates');
      console.error('onALEKSMasterTemplateRetreivalFailure > errorResponse: ', errorResponse);
    }
  }

  /**
   * Callback to successful fetch request for Resoureces, checks to see if the response for Resource has 1:1 mapping
   * of product and resources, iff true it assign that resource into entitler object and skips the resource view, else
   * pass the data to resource view for user selection.
   * @param {Object} successResponse resource data
   */
  onResourceRetreivalSuccess(successResponse) {
    const resources = successResponse.data.content.data;
    const isSingleNonAleksResource = _.size(resources) === 1 && !this.areAleksResources(resources);

    if(isSingleNonAleksResource) {
      //set the resource in entitler since resource to product is 1:1 mapping we autoassign resources.
      this.entitler.selectedResources = [];
      this.entitler.isResourcesAutoAssigned = true;
      this.entitler.selectedResources = resources;
      //nav to courses pages
      this.$state.go('home.assign.assignments', {
        tabName: 'courses'
      });
    } else {
      //pass the fetch resources data to the view.
      this.entitler.allResources = resources;
      this.$state.go('home.assign.resourceSelector', {data: successResponse});
    }
  }

  doesPlatformHasResourceView(platform){
    const platformHavingResources= ['redbird', 'aleks', 'studysync', 'lars', 'apr', 'al', 'a3k', 'a3k_math', 'a3k_literacy', 'readinglabs'];
    return _.includes(platformHavingResources, (platform ? platform.toLowerCase() : ''));
  }

  hasAnyAleksProducts(products) {
    return _.some(products, { 'platform': 'aleks' });
  }

  areAleksResources(products) {
    return _.some(products, { 'sourceName': 'aleks' });
  }

  setEntitlerDefaults() {
    this.entitler.isProductsUnassignmentSuccessful = false;
    this.entitler.isResourcesAutoAssigned = false;
  }

  getSelectedProduct(list, selectedValue) {
    let productById = _.find(list, { id: selectedValue });

    if(!productById){
      productById = _.find(list, { aleksMasterTemplateId: selectedValue });
    }
    if(!productById){
      productById = _.find(list, { resourceId: selectedValue });
    }

    return productById;
  }

  getNextSetOfRowsToFetch() {
    this.getProducts();
  }

  toggleSort(columnName, descendingFlag) {
    this.setSortOrderAndColumn(columnName, descendingFlag);
    this.resetPaginationDefaults();
    this.getProducts();
  }

  setSortOrderAndColumn(columnName, descendingFlag) {
    this.sortBy.column = columnName;
    this.sortBy.order = descendingFlag ? this.sort.descending : this.sort.ascending;
  }

  resetPaginationDefaults() {
    this.offset = 0;
    this.previousData = {
      content: []
    };
  }

  isProductsUnassignmentSuccessful() {
    return this.entitler.isProductsUnassignmentSuccessful;
  }

  search() {
    this.searchValue = this.metaData.entitler.search.value;
    this.resetPaginationDefaults();
    this.getProducts();
  }


  goToPreviousState() {
    if(this.$state.current.name === 'home.assign.aleksMasterTemplateSelector'){
      this.entitler.selectedResources = [];
      this.entitler.selectedAleksMasterTemplate = [];
      this.$state.go('home.assign.resourceSelector');
    } else {
      this.$state.go('home.assign.productsSelector');
    }
  }
}

ProductsSelectorController.$inject = ['entitlerService', '$state', '$scope', 'navBarService', 'statusIndicatorService', 'localStorageService', 'config', 'AuthenticationService', 'customerIntegrationsService'];

export
default ProductsSelectorController;



// WEBPACK FOOTER //
// ./app/components/productsSelector/productsSelector.controller.js